<template>
  <div class="http">
    <h3>Интеграция CRMCalls CC</h3>

    <div class="token-row">
    <v-select
      v-model="data_local.crmcalls_integration_id"
      :items="integrations"
      item-text="name"
      item-value="guid"
      :loading="integrationsLoading"
      :disabled="integrationsLoading"
      height="40"
      placeholder="Выберите интеграцию"
      no-data-text="Добавьте подключение в разделе «Интеграции»"
      hide-details
      solo
      @change="onIntegrationChange"
    />

    <button type="button" class="load-fields-btn" :disabled="fieldsLoading || !data_local.crmcalls_integration_id" @click="loadCustomFields">
      {{ fieldsLoading ? 'Загружаем...' : 'Загрузить поля CC' }}
    </button>
    </div>
    <div v-if="integrationMessage" class="section-hint">{{ integrationMessage }}</div>
    <div v-if="fieldsMessage" class="section-hint">{{ fieldsMessage }}</div>

    <h3 class="deduplication-title">Режим дедупликации</h3>

    <v-select
      v-model="data_local.deduplication_mode"
      :items="deduplicationModes"
      item-text="text"
      item-value="value"
      height="40"
      hide-details
      solo
      @change="emitData"
    />

    <div class="section-title">
      <div class="section-name">Обязательные поля</div>

      <div class="section-hint">
        Заполняются автоматически при выполнении сценария
      </div>
    </div>

    <div class="post-columns fixed-columns">
      <div>
        <div class="post-column-title">Данные CRMCalls</div>
      </div>

      <div></div>

      <div>
        <div class="post-column-title">Поле CRMCalls CC</div>
      </div>

      <div></div>
    </div>

    <div class="post-row fixed-row">
      <v-text-field
        value="Номер текущего контакта"
        height="40"
        hide-details
        solo
        disabled
      />

      <span class="post-arrow">→</span>

      <v-text-field value="phones" height="40" hide-details solo disabled />

      <div></div>
    </div>

    <div class="post-row fixed-row">
      <v-text-field
        value="ID текущего лида"
        height="40"
        hide-details
        solo
        disabled
      />

      <span class="post-arrow">→</span>

      <v-text-field
        value="external_id"
        height="40"
        hide-details
        solo
        disabled
      />

      <div></div>
    </div>

    <div class="section-title">
      <div class="section-name">Дополнительные поля</div>
    </div>

    <div class="post-columns">
      <div>
        <div class="post-column-title">Данные CRMCalls</div>

        <div class="post-column-hint">Что отправляем</div>
      </div>

      <div></div>

      <div>
        <div class="post-column-title">Поле CRMCalls CC</div>

        <div class="post-column-hint">Куда отправляем</div>
      </div>

      <div></div>
    </div>

    <div v-for="(row, index) in contactRows" :key="index" class="post-row">
      <div class="source-field">
        <v-select
          v-model="row.source"
          :items="contactSources"
          item-text="text"
          item-value="value"
          placeholder="Что отправить"
          height="40"
          hide-details
          solo
          @change="onSourceChange(row)"
        />

        <v-text-field
          v-if="row.source === 'custom'"
          v-model="row.customSource"
          placeholder="Название поля"
          height="40"
          hide-details
          solo
          @input="emitData"
        />

        <v-text-field
          v-if="row.source === 'static'"
          v-model="row.staticValue"
          placeholder="Статичное значение"
          height="40"
          hide-details
          solo
          @input="emitData"
        />
      </div>

      <span class="post-arrow">→</span>

      <div class="source-field">
      <v-select
        v-model="row.target"
        :items="getContactTargetOptions(row)"
        item-text="text"
        item-value="value"
        placeholder="Поле CRMCalls CC"
        height="40"
        hide-details
        solo
        @change="emitData"
      />
      <v-select
        v-if="row.target === 'custom_fields'"
        v-model="row.customTarget"
        :items="getCustomFieldOptions(row)"
        item-text="text"
        item-value="value"
        placeholder="Пользовательское поле CC"
        height="40"
        hide-details
        solo
        @change="emitData"
      />
      </div>

      <button type="button" class="remove-row" aria-label="Удалить поле" @click="removeRow(index)">
        ×
      </button>
    </div>

    <div class="actions-row">
      <button type="button" class="add-row" @click="addRow">
        + Добавить поле
      </button>

      <button
        type="button"
        class="test-webhook-btn"
        :disabled="testLoading"
        @click="openCrmCallsTest"
      >
        {{ testLoading ? 'Проверяем...' : 'Проверить вебхук' }}
      </button>
    </div>

    <div
      v-if="testDialog"
      class="webhook-test-overlay"
      @click.self="closeTestDialog"
    >
      <div class="webhook-test-modal">
        <button type="button" class="test-close" aria-label="Закрыть проверку" :disabled="testLoading || testSending" @click="closeTestDialog">
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" aria-hidden="true" focusable="false">
            <path d="M6 6l12 12M18 6L6 18" />
          </svg>
        </button>

        <h3>Проверка отправки в CRMCalls CC</h3>

        <div v-if="testFixedFields.length" class="test-info-card">
          <div class="test-field-label">Данные тестового контакта</div>
          <dl class="test-fixed-fields">
            <div v-for="field in testFixedFields" :key="field.name">
              <dt>{{ field.name }}</dt>
              <dd>{{ field.value }}</dd>
            </div>
          </dl>
        </div>

        <div v-if="customTestRows.length" class="section-hint">
          Проверьте тестовые значения. Пустые поля не отправляются.
        </div>

        <div v-for="(row, index) in customTestRows" :key="index" class="test-info-card">
          <label class="test-field-label" :for="`cc-test-field-${index}`">{{ customFieldLabel(row.customTarget) }}</label>
          <v-text-field
            :id="`cc-test-field-${index}`"
            v-model="row.testValue"
            :placeholder="customFieldPlaceholder(row.customTarget)"
            :disabled="testLoading || testSending"
            @input="previewCrmCallsTest"
            hide-details
            solo
          />
        </div>

        <div class="test-info-card">
          <div class="test-info-label">Режим дедупликации</div>

          <div class="test-info-value">
            {{ deduplicationModes.find((mode) => mode.value === data_local.deduplication_mode).text }}
          </div>
        </div>

        <div v-if="Object.keys(testPayload).length">
          <div class="test-info-card">
            Будет отправлен тестовый контакт.
            Пользовательских полей: {{ testPayload.custom_fields_count }}.
          </div>

          <button
            type="button"
            class="test-send-btn"
            :disabled="testSending || testLoading || !testFixedFields.length"
            @click="sendCrmCallsTest"
          >
            {{ testSending ? 'Отправляем...' : 'Отправить вебхук' }}
          </button>
        </div>

        <div v-if="testLoading" class="test-loading">
          Выполняется проверка...
        </div>

        <div
          v-if="testResult"
          class="test-result"
          :class="{
            'test-result--success': testResult.ok,
            'test-result--error': !testResult.ok,
          }"
        >
          <div class="test-result-title">
            {{ testResult.ok ? 'Запрос выполнен' : 'Ошибка запроса' }}
          </div>

          <div class="test-result-message">{{ testResult.message }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SendCrmCalls',

  props: ['data', 'edit_callback'],

  data() {
    const savedData = JSON.parse(JSON.stringify(this.data || {}));

    const savedRows = Array.isArray(savedData.contact_mapping)
      ? savedData.contact_mapping
          .filter((row) => {
            return row.target !== 'phones' && row.target !== 'external_id';
          })
          .map((row) => ({
            source: row.source || (row.field ? 'custom' : ''),
            customSource:
              row.customSource || row.field || row.source_value || '',
            customTarget: row.customTarget || '',
            staticValue: row.staticValue || '',
            target: row.target || '',
          }))
      : [];

    return {
      data_local: {
        ...savedData,

        link: savedData.link || '',

        crmcalls_integration_id: savedData.crmcalls_integration_id || '',

        deduplication_mode: savedData.deduplication_mode || 'update',
      },

      contactRows: savedRows,
      integrations: [],
      integrationsLoading: false,
      integrationMessage: '',
      customFields: Array.isArray(savedData.cc_custom_fields) ? savedData.cc_custom_fields : [],
      fieldsLoading: false,
      fieldsMessage: '',
      customTestRows: [],
      testFixedFields: [],

      testDialog: false,
      testLoading: false,
      testResult: null,
      testPayload: {},
      testSending: false,

      contactTargets: [
        { text: 'Пользовательское поле CC', value: 'custom_fields' },
        {
          text: 'ФИО',
          value: 'full_name',
        },
        {
          text: 'Email',
          value: 'email',
        },
        {
          text: 'Сайт',
          value: 'site',
        },
        {
          text: 'Город',
          value: 'city',
        },
        {
          text: 'Адрес',
          value: 'address',
        },
        {
          text: 'Регион',
          value: 'region',
        },
        {
          text: 'Должность',
          value: 'position',
        },
        {
          text: 'Теги',
          value: 'tags',
        },
        {
          text: 'Ответственный',
          value: 'responsible_id',
        },
      ],

      contactSources: [
        // {
        //   text: 'Номер клиента',
        //   value: 'phone',
        // },
        {
          text: 'Номер с которого звонили',
          value: 'phoneA',
        },
        // {
        //   text: 'ID лида',
        //   value: 'lead_id',
        // },
        {
          text: 'Название обзвона',
          value: 'callname',
        },
        {
          text: 'Запись звонка',
          value: 'record',
        },
        {
          text: 'Название цели',
          value: 'target',
        },
        {
          text: 'Текст разговора',
          value: 'text',
        },
        {
          text: 'Название сценария',
          value: 'script',
        },
        {
          text: 'Название базы',
          value: 'base',
        },
        {
          text: 'Пользовательское поле',
          value: 'custom',
        },
        {
          text: 'Статичное значение',
          value: 'static',
        },
      ],

      deduplicationModes: [
        {
          text: 'Обновить найденный контакт',
          value: 'update',
        },
        {
          text: 'Пропустить найденный контакт',
          value: 'skip',
        },
        {
          text: 'Всегда создать новый контакт',
          value: 'ignore',
        },
      ],
    };
  },

  mounted() {
    this.loadIntegrations();
    this.emitData();
  },

  methods: {
    loadIntegrations() {
      this.integrationsLoading = true;
      this.integrationMessage = '';
      this.$http.post('integrations/list', { type: 'CrmCallsCC' }, (response) => {
        this.integrationsLoading = false;
        if (!Array.isArray(response)) {
          this.integrationMessage = 'Не удалось загрузить подключения. Повторите попытку.';
          return;
        }
        this.integrations = response;
        if (this.data_local.crmcalls_integration_id && !response.some((item) => item.guid === this.data_local.crmcalls_integration_id)) {
          this.integrationMessage = 'Выбранное подключение удалено или недоступно. Выберите другое.';
        }
      });
    },

    onIntegrationChange() {
      this.customFields = [];
      this.customTestRows = [];
      this.testFixedFields = [];
      this.testPayload = {};
      this.testResult = null;
      delete this.data_local.api_token;
      this.fieldsMessage = '';
      this.contactRows.forEach((row) => { row.customTarget = ''; });
      this.emitData();
    },

    loadCustomFields() {
      const integrationId = this.data_local.crmcalls_integration_id;
      if (!integrationId) return alert('Выберите интеграцию CRMCalls CC');
      this.fieldsLoading = true;
      this.fieldsMessage = '';
      this.$http.post('integrations/crmcalls_custom_fields', { crmcalls_integration_id: integrationId }, (response) => {
        this.fieldsLoading = false;
        if (integrationId !== this.data_local.crmcalls_integration_id) return;
        if (!response || !response.ok) {
          this.fieldsMessage = (response && response.message) || 'Не удалось загрузить поля CC';
          return;
        }
        this.customFields = response.custom_fields;
        this.contactRows.forEach((row) => {
          if (row.customTarget && !this.customFields.some((field) => String(field.id) === row.customTarget)) {
            row.customTarget = '';
          }
        });
        this.fieldsMessage = '';
        this.emitData();
      });
    },

    getCustomFieldOptions(currentRow) {
      return this.customFields.map((field) => ({
        text: field.name,
        value: String(field.id),
        disabled: this.contactRows.some((row) => row !== currentRow && row.target === 'custom_fields' && row.customTarget === String(field.id)),
      }));
    },

    customFieldLabel(id) {
      const field = this.customFields.find((item) => String(item.id) === id);
      return field ? field.name : `Поле CC ${id}`;
    },

    customFieldPlaceholder(id) {
      const field = this.customFields.find((item) => String(item.id) === id);
      const examples = {
        datetime: 'Например: 2026-10-30T12:00:00+03:00',
        date: 'Например: 2026-10-30',
        number: 'Например: 150000',
        boolean: 'Да или Нет',
        select: 'Название варианта из списка CC',
        url: 'Например: https://example.com',
      };
      return (field && examples[field.type]) || 'Тестовое значение вместо данных лида';
    },

    testCustomFields() {
      const fields = {};
      this.customTestRows.forEach((row) => {
        const value = String(row.testValue || '').trim();
        if (value) fields[row.customTarget] = value;
      });
      return fields;
    },

    defaultTestValue(field) {
      if (field.type === 'select') {
        return field.options && field.options.length ? field.options[0].name : '';
      }
      const now = new Date().toISOString();
      const values = {
        text: 'Проверка из CRMCalls',
        textarea: 'Тестовое значение пользовательского поля из CRMCalls',
        number: '150000',
        boolean: 'Да',
        date: now.slice(0, 10),
        datetime: now,
        url: 'https://example.com',
      };
      return values[field.type] || '';
    },

    onSourceChange(row) {
      if (row.source !== 'custom') {
        row.customSource = '';
      }

      if (row.source !== 'static') {
        row.staticValue = '';
      }

      this.emitData();
    },

    getContactTargetOptions(currentRow) {
      const selectedTargets = this.contactRows
        .filter((row) => row !== currentRow && row.target)
        .map((row) => row.target);

      return this.contactTargets.map((target) => ({
        ...target,
        disabled:
          !['tags', 'custom_fields'].includes(target.value) && selectedTargets.includes(target.value),
      }));
    },
    addRow() {
      this.contactRows.push({
        source: '',
        customSource: '',
        customTarget: '',
        staticValue: '',
        target: '',
      });

      this.emitData();
    },

    removeRow(index) {
      this.contactRows.splice(index, 1);
      this.emitData();
    },

    emitData() {
      if (this.data_local.crmcalls_integration_id) delete this.data_local.api_token;
      this.data_local.cc_custom_fields = JSON.parse(JSON.stringify(this.customFields));
      this.data_local.contact_mapping = JSON.parse(
        JSON.stringify(this.contactRows.map((row) => ({
          source: row.source,
          customSource: row.customSource,
          customTarget: row.customTarget,
          staticValue: row.staticValue,
          target: row.target,
        }))),
      );

      this.edit_callback(JSON.parse(JSON.stringify(this.data_local)));
    },

    openCrmCallsTest() {
      if (!this.data_local.crmcalls_integration_id) {
        alert('Выберите интеграцию CRMCalls CC');
        return;
      }

      this.testDialog = true;
      this.customTestRows = this.customFields.map((field) => ({
        customTarget: String(field.id),
        testValue: this.defaultTestValue(field),
      }));
      this.previewCrmCallsTest();
      this.loadTestFixedFields();
    },

    loadTestFixedFields() {
      this.testFixedFields = [];
      this.testLoading = true;
      this.$http.post('integrations/test_crmcalls_contact_preview', {
        crmcalls_integration_id: this.data_local.crmcalls_integration_id,
        custom_fields: this.testCustomFields(),
        deduplication_mode: this.data_local.deduplication_mode || 'update',
      }, (response) => {
        this.testLoading = false;
        if (response && response.ok && response.summary && Array.isArray(response.summary.fixed_fields)) {
          this.testFixedFields = response.summary.fixed_fields;
        } else if (response && response.ok && response.body) {
          // Совместимость со старым бэкендом: показываем только разрешённые поля.
          const body = response.body;
          this.testFixedFields = [
            { name: 'ФИО', value: body.full_name },
            { name: 'Телефон', value: Array.isArray(body.phones) ? body.phones.join(', ') : '' },
            { name: 'Email', value: body.email },
            { name: 'Город', value: body.city },
            { name: 'Регион', value: body.region },
          ];
        } else {
          this.testResult = { ok: false, message: 'Не удалось получить данные тестового контакта. Обновите бэкенд и повторите проверку.' };
        }
      });
    },

    previewCrmCallsTest() {
      this.testLoading = false;
      this.testResult = null;
      this.testPayload = {
        custom_fields_count: Object.keys(this.testCustomFields()).length,
      };
    },

    sendCrmCallsTest() {
      if (!this.data_local.crmcalls_integration_id) {
        alert('Выберите интеграцию CRMCalls CC');
        return;
      }

      this.testSending = true;
      this.testResult = null;

      this.$http.post(
        'integrations/test_crmcalls_contact',
        {
          crmcalls_integration_id: this.data_local.crmcalls_integration_id,
          custom_fields: this.testCustomFields(),
          deduplication_mode: this.data_local.deduplication_mode || 'update',
        },
        (response) => {
          this.testSending = false;

          const ok = Boolean(response && response.ok);
          const isLegacyResponse = response && ('data' in response || 'payload' in response || 'status' in response);
          this.testResult = {
            ok,
            message: response && !isLegacyResponse && response.message
              ? response.message
              : ok
                ? 'Тестовая отправка выполнена. Проверьте контакт в CC.'
                : 'Отправка не выполнена. Проверьте токен, значения полей и режим дедупликации.',
          };
        },
      );
    },

    closeTestDialog() {
      if (this.testLoading || this.testSending) return;

      this.testDialog = false;
    },
  },
};
</script>

<style scoped>
.http {
  width: 690px;
  max-width: 100%;
  margin: 0 auto;
  text-align: left;
  box-sizing: border-box;
}

.token-row {
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto;
  align-items: start;
  gap: 12px;
}

.load-fields-btn {
  min-height: 40px;
  padding: 0 16px;
  color: #4b5eff;
  background: #fff;
  border: 1px solid #4b5eff;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 600;
  white-space: nowrap;
  cursor: pointer;
}

.load-fields-btn:hover { background: #f3f4ff; }

.deduplication-title { margin-top: 24px; }

.http ::v-deep .v-input { min-width: 0; }
.http ::v-deep .v-input__slot { margin-bottom: 0; }

h3 {
  margin-bottom: 12px;
  text-align: left;
}

.section-title {
  margin-top: 28px;
  margin-bottom: 16px;
  text-align: center;
}

.section-name {
  color: #333;
  font-size: 18px;
  font-weight: 600;
}

.section-hint {
  margin-top: 3px;
  color: #8b8d98;
  font-size: 13px;
  line-height: 1.5;
}

.post-columns {
  display: grid;
  grid-template-columns: minmax(0, 1fr) 24px minmax(0, 1fr);
  gap: 10px;
  padding: 0 13px;
  margin-bottom: 8px;
}

.post-column-title {
  color: #333;
  font-size: 14px;
  font-weight: 600;
}

.post-columns > div:nth-child(3) {
  text-align: right;
}

.post-columns > div:last-child {
  display: none;
}

.post-column-hint {
  margin-top: 3px;
  color: #8b8d98;
  font-size: 12px;
}

.post-row {
  position: relative;
  display: grid;
  grid-template-columns: minmax(0, 1fr) 24px minmax(0, 1fr);
  align-items: start;
  gap: 10px;
  padding: 12px;
  margin-bottom: 10px;
  background: #f7f8ff;
  border: 1px solid #e2e5ff;
  border-radius: 12px;
}

.fixed-row {
  opacity: 0.85;
}

.fixed-row,
.fixed-columns {
  grid-template-columns: minmax(0, 1fr) 24px minmax(0, 1fr);
}

.fixed-row > div:last-child,
.fixed-columns > div:last-child {
  display: none;
}

.post-arrow {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 40px;
  color: #8b8d98;
  font-size: 20px;
  text-align: center;
}

.remove-row {
  position: absolute;
  right: -40px;
  top: 17px;
  width: 30px;
  height: 30px;
  color: #ef4444;
  background: #fff;
  border: 1px solid #ffd5d5;
  border-radius: 8px;
  font-size: 20px;
  line-height: 26px;
  cursor: pointer;
  transition: 0.2s;
}

.remove-row:hover {
  color: #fff;
  background: #ef4444;
}

.actions-row {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  gap: 10px;
  margin-top: 16px;
}

.add-row,
.test-webhook-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 180px;
  min-height: 40px;
  padding: 10px 16px;
  margin: 0;
  box-sizing: border-box;
  border-radius: 8px;
  font-weight: 600;
  line-height: normal;
  cursor: pointer;
}

.add-row {
  color: #4b5eff;
  background: #fff;
  border: 1px dashed #4b5eff;
}

.add-row:hover {
  background: #f3f4ff;
}

.test-webhook-btn {
  color: #fff;
  background: #4b5eff;
  border: 1px solid #4b5eff;
}

.test-webhook-btn:hover {
  color: #fff;
  background: #3949e8;
}

.test-webhook-btn:disabled,
.add-row:disabled,
.load-fields-btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.webhook-test-overlay {
  position: fixed;
  inset: 0;
  z-index: 9999;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
  background: rgba(0, 0, 0, 0.45);
}

.webhook-test-modal {
  position: relative;
  width: 650px;
  max-width: 100%;
  max-height: 90vh;
  padding: 26px;
  overflow-y: auto;
  background: #fff;
  border-radius: 16px;
  text-align: left;
  box-sizing: border-box;
}

.webhook-test-modal > h3 { padding-right: 36px; }
.preview-btn { margin-top: 16px; }

.test-close {
  position: absolute;
  top: 14px;
  right: 14px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  padding: 0;
  color: #676a76;
  background: transparent;
  border: 0;
  border-radius: 8px;
  cursor: pointer;
  transition: color 0.15s, background-color 0.15s;
}

.test-close:hover:not(:disabled) {
  color: #4b5eff;
  background: #f3f4ff;
}

.test-close:focus-visible {
  outline: 2px solid #4b5eff;
  outline-offset: 2px;
}

.test-close:disabled { opacity: 0.45; cursor: default; }

.test-info-card {
  padding: 14px 16px;
  margin-top: 12px;
  background: #f8f9fc;
  border: 1px solid #e5e7ef;
  border-radius: 10px;
}

.test-info-label {
  color: #8b8d98;
  font-size: 12px;
}

.test-field-label {
  display: block;
  margin-bottom: 8px;
  color: #2b2d33;
  font-size: 14px;
  font-weight: 600;
}

.test-fixed-fields { margin: 0; }
.test-fixed-fields > div {
  display: grid;
  grid-template-columns: 90px minmax(0, 1fr);
  gap: 12px;
  padding: 5px 0;
  font-size: 14px;
}
.test-fixed-fields dt { color: #808185; }
.test-fixed-fields dd { margin: 0; overflow-wrap: anywhere; }

.test-result-message {
  margin-top: 8px;
  line-height: 1.5;
}

.test-info-value {
  margin-top: 4px;
  color: #2b2d33;
  font-weight: 600;
}

.test-loading {
  margin-top: 18px;
  color: #4b5eff;
  text-align: center;
}

.test-result {
  padding: 14px 16px;
  margin-top: 16px;
  border-radius: 10px;
}

.test-result--success {
  background: #effaf3;
  border: 1px solid #b9e7c8;
}

.test-result--error {
  background: #fff3f3;
  border: 1px solid #ffd0d0;
}

.test-result-title {
  font-weight: 600;
}

.test-result pre {
  max-height: 250px;
  margin-top: 10px;
  overflow: auto;
  white-space: pre-wrap;
  word-break: break-word;
}

@media (max-width: 650px) {
  .http {
    width: 100%;
  }

  .actions-row {
    align-items: stretch;
    flex-direction: column;
  }

  .token-row { grid-template-columns: minmax(0, 1fr); }
  .load-fields-btn { justify-self: start; }
  .actions-row > button { width: 100%; min-width: 0; }
  .post-row, .post-columns {
    grid-template-columns: minmax(0, 1fr) 16px minmax(0, 1fr);
    gap: 6px;
  }
  .remove-row {
    position: static;
    grid-column: 3;
    justify-self: end;
    width: 26px;
  }
  .fixed-row, .fixed-columns {
    grid-template-columns: minmax(0, 1fr) 16px minmax(0, 1fr);
  }
  .webhook-test-overlay { padding: 12px; }
  .webhook-test-modal { padding: 20px 16px; }
}
.test-payload-title {
  margin-top: 18px;
  margin-bottom: 8px;
  color: #2b2d33;
  font-size: 15px;
  font-weight: 700;
}

.test-payload {
  max-height: 260px;
  padding: 18px;
  overflow: auto;
  color: #dfe3ff;
  background: #202338;
  border-radius: 10px;
  font-size: 13px;
  white-space: pre-wrap;
  word-break: break-word;
}

.test-send-btn {
  display: block;
  padding: 11px 18px;
  margin: 14px auto 0;
  color: #fff;
  background: #4b5eff;
  border: 0;
  border-radius: 8px;
  font-weight: 600;
  cursor: pointer;
}

.test-send-btn:hover {
  background: #3949e8;
}

.test-send-btn:disabled {
  cursor: not-allowed;
  opacity: 0.45;
}
.source-field {
  display: flex;
  flex-direction: column;
  gap: 8px;
  min-width: 0;
}
</style>
